import { Div, Link } from '@tblabs/truffle';
import { appendable } from '@tblabs/truffle/Core/appendable';


export class Screen extends Div
{
    constructor(...components: appendable[])
    {
        super("splash-screen");

        this.Append(
            new Div().TextAlignCenter()
                .Append(...components
                ),
            new Link("×").Class("x-button")
                .OnClick(() => this.RemoveSelf())
        );
    }
}
